import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes.ts';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { Resolver, useForm } from 'react-hook-form';
import { cloneDeep } from 'lodash';
import {
  getFinancialConditionInitialValuesLegalResident,
  getFinancialConditionInitialValuesSoleTrader,
} from '~/modules/identification/forms/FinancialCondition/utils.ts';
import {
  TFinancialCondition,
  TFinancialConditionLegalResident,
  TFinancialConditionSoleTrader,
} from '~/modules/identification/forms/FinancialCondition/types.ts';
import {
  financialConditionLegalResidentValidationSchema,
  financialConditionSoleTraderValidationSchema,
} from '~/modules/identification/forms/FinancialCondition/validSchema/FormValidationSchema.ts';
import { yupResolver } from '@hookform/resolvers/yup';
import { selectFinancialState } from '~/store/identification-form/selectors';

export const useFinancialConditionForm = () => {
  const { isSoleTrader } = useGetContragentTypes();
  const financialState = useSelector(selectFinancialState);

  const initialValues = (
    isSoleTrader
      ? getFinancialConditionInitialValuesSoleTrader(
          financialState as TFinancialConditionSoleTrader
        )
      : getFinancialConditionInitialValuesLegalResident(
          financialState as TFinancialConditionLegalResident
        )
  ) as TFinancialCondition;

  const schema = yup.lazy(() => {
    return isSoleTrader
      ? financialConditionSoleTraderValidationSchema
      : financialConditionLegalResidentValidationSchema;
  }) as unknown as yup.ObjectSchema<TFinancialCondition>;

  return useForm<TFinancialCondition>({
    resolver: yupResolver(schema) as unknown as Resolver<TFinancialCondition>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });
};
